import styled from '@emotion/styled'
import { theme } from '@hhgtech/hhg-components'
import { Text } from '@hhgtech/hhg-components/mantine'
import { rem } from '@mantine/core'

export const StyledCardArticleAuthorLabel = styled(Text)`
  flex: 1;
  min-width: 0;
  margin: 0;
  color: ${theme.colors.gray600};

  a,
  .author-name {
    color: ${theme.colors.gray800};
  }
`

export const StyledCardArticleAuthorWrap = styled.a`
  display: block;
  width: ${rem(24)};
  height: ${rem(24)};
  line-height: 0;
  span:first-child {
    font-weight: 500;
  }

  .cardArticleAuthorIndicator,
  .cardArticleAuthorAvatar {
    width: 100%;
    height: 100%;
    min-width: unset;
    max-width: unset;
  }
`

export const StyledCardArticleAuthor = styled.div`
  display: flex;
  align-items: center;
  gap: ${rem(8)};
`
